// @ts-nocheck
import ReportsService from '../../services/ReportsService';
import {
    BETS_MONITOR_REPORTS_DATA_CHANGED,
    SALES_REPORTS_CHANGED,
    SALES_REPORTS_FILTERED,
    BETS_MONITOR_REPORTS_DATA_CLEARED,
    SALES_FILTERS_CHANGED,
    ONLINE_PLAYERS_REPORT_CHANGED,
    ONLINE_PLAYERS_REPORT_CLEARED,
    FROZEN_ACCOUNTS_REPORT_DATA_CHANGED,
    FROZEN_ACCOUNTS_REPORT_DATA_CLEARED,
    REGISTRATIONS_HISTORY_REPORTS_CHANGED,
    REGISTRATIONS_HISTORY_REPORTS_CLEARED,
    MONEY_TRANSACTIONS_DATA_CHANGED,
    MONEY_TRANSACTIONS_DETAILS_CHANGED,
    MONEY_TRANSACTIONS_ALL_DATA_CLEARED,
    INACTIVE_PLAYERS_REPORT_DATA_CHANGED,
    SPORT_PERFORMANCE_DATA_CHANGED,
    SPORT_PERFORMANCE_DATA_CLEARED,
    INACTIVE_PLAYERS_REPORT_DATA_CLEARED,
    AUDIT_TRAIL_REPORT_DATA_CHANGED,
    AUDIT_TRAIL_REPORT_DATA_CLEARED,
    SPORT_PERFORMANCE_LOADING_CHANGED,
    TICKET_OPERATIONS_HISTORY_REPORTS_CLEARED,
    TICKET_OPERATIONS_HISTORY_REPORTS_CHANGED,
} from '../types';
import { getNewCancelToken } from '../../utils/api';
import { CANCEL_TOKEN_KEYS, FILTER_PARAMS, PAGINATION_KEYS } from '../../utils/constants';
import { setPagination } from './pagination';
import getUniqueListByKey from '../../utils/methods/getUniqueListBy';
import LocalStorage, { LOCAL_STORAGE_KEYS } from '../../utils/LocalStorage';
import moment from 'moment';

export const changeSalesReports = payload => ({
    type: SALES_REPORTS_CHANGED,
    payload,
});

export const changeSalesFilters = payload => ({
    type: SALES_FILTERS_CHANGED,
    payload,
});

export const getSalesReports =
    ({ filters }) =>
    async dispatch => {
        dispatch(changeSalesReports({ isFetching: true, reports: [], summary: {} }));

        const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.salesReports);

        const { info, item } = await ReportsService.getSalesReports({
            filters,
            cancelToken,
        });

        if (!info.success) {
            dispatch(changeSalesReports({ isFetching: false }));
            return;
        }

        const { sales, ...salesSummary } = item;

        dispatch(changeSalesReports({ isFetching: false, reports: sales, summary: salesSummary }));

        return item;
    };

export const filterSalesReports = newReports => ({
    type: SALES_REPORTS_FILTERED,
    payload: newReports,
});

export const clearSalesReports = () => dispatch => {
    dispatch(setSalesReports([]));
    dispatch(filterSalesReports([]));
};

export const setSalesReports = payload => ({
    type: SALES_REPORTS_CHANGED,
    payload,
});

export const setBetMonitorData = payload => ({
    type: BETS_MONITOR_REPORTS_DATA_CHANGED,
    payload: payload,
});

export const clearBetMonitorData = () => ({
    type: BETS_MONITOR_REPORTS_DATA_CLEARED,
});

export const fetchBetsMonitorReports = params => async (dispatch, getStore) => {
    saveBetsMonitorFilters({ ...params });

    let currentReports = getStore().reports.betsMonitor.reports;
    let newReports = params.pageIndex > 0 ? currentReports : [];

    dispatch(setBetMonitorData({ reports: newReports }));
    dispatch(
        setPagination(PAGINATION_KEYS.betsMonitor, {
            isFetching: true,
        }),
    );

    const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.betsMonitor);

    const startDate = moment().subtract(params.lastXMinutes, 'minute').valueOf();
    const endDate = moment().valueOf();

    let { lastXMinutes, ...newParams } = params;

    newParams = {
        ...newParams,
        startDate,
        endDate,
    };

    const { info, items: reports } = await ReportsService.getBetMonitorReports({
        params: newParams,
        cancelToken,
    });

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.betsMonitor, {
                isFetching: false,
            }),
        );
        return;
    }

    currentReports = getStore().reports.betsMonitor.reports;
    newReports = getUniqueListByKey(currentReports.concat(reports), 'id');

    const hasMore = reports.length >= params.pageSize;

    dispatch(
        setBetMonitorData({
            reports: newReports,
        }),
    );

    dispatch(
        setPagination(PAGINATION_KEYS.betsMonitor, {
            hasMore,
            page: params.pageIndex,
            isFetching: false,
        }),
    );

    return newReports;
};

const saveBetsMonitorFilters = filters => {
    const ignoredFields = [
        FILTER_PARAMS.sportId,
        FILTER_PARAMS.categoryIds,
        FILTER_PARAMS.leagueIds,
        FILTER_PARAMS.eventIds,
        FILTER_PARAMS.marketRefIds,
    ];

    ignoredFields.forEach(field => {
        delete filters[field];
    });

    const { startAmountRangeType } = filters;
    if (typeof startAmountRangeType === 'number') {
        filters[FILTER_PARAMS.amountType] = startAmountRangeType;
    }

    LocalStorage.setItem(LOCAL_STORAGE_KEYS.betsMonitorFilters, filters);
};

export const getOnlinePlayersReport = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentReports = store.reports.onlinePlayers.reports || [];

    dispatch(setOnlinePlayersReport({ reports: params.offset > 0 ? currentReports : [] }));
    dispatch(
        setPagination(PAGINATION_KEYS.onlinePlayersReport, {
            isFetching: true,
        }),
    );

    const { info, item } = await ReportsService.getOnlinePlayersReport(params);

    const { players, ...summary } = item;

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.onlinePlayersReport, {
                isFetching: false,
            }),
        );
        return;
    }

    let newReports = [];

    if (params.offset > 0) {
        newReports = currentReports.concat(players);
    } else {
        newReports = players;
    }

    const hasMore = players.length >= params.limit;

    dispatch(
        setOnlinePlayersReport({
            reports: newReports,
            summary,
        }),
    );

    dispatch(
        setPagination(PAGINATION_KEYS.onlinePlayersReport, {
            page: params.offset,
            hasMore,
            isFetching: false,
        }),
    );

    return newReports;
};

export const setOnlinePlayersReport = payload => ({
    type: ONLINE_PLAYERS_REPORT_CHANGED,
    payload,
});
export const clearOnlinePlayersReport = () => ({
    type: ONLINE_PLAYERS_REPORT_CLEARED,
});

export const getFrozenAccountsReport = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentFrozenAccountList = store.reports.frozenAccountsList;

    dispatch(setFrozenAccountsReport(params.offset > 0 ? currentFrozenAccountList : []));
    dispatch(
        setPagination(PAGINATION_KEYS.frozenAccountsReport, {
            isFetching: true,
        }),
    );

    const { info, items } = await ReportsService.getFrozenAccount(params);

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.frozenAccountsReport, {
                isFetching: false,
            }),
        );
        return;
    }

    let newFrozenAccountList = [];

    if (params.offset > 0) {
        newFrozenAccountList = currentFrozenAccountList.concat(items);
    } else {
        newFrozenAccountList = items;
    }

    const hasMore = items.length >= params.limit;

    dispatch(setFrozenAccountsReport(newFrozenAccountList));

    dispatch(
        setPagination(PAGINATION_KEYS.frozenAccountsReport, {
            page: params.offset,
            size: params.limit,
            hasMore,
            isFetching: false,
        }),
    );

    return newFrozenAccountList;
};

export const setFrozenAccountsReport = payload => ({
    type: FROZEN_ACCOUNTS_REPORT_DATA_CHANGED,
    payload,
});

export const clearFrozenAccountsReport = () => ({
    type: FROZEN_ACCOUNTS_REPORT_DATA_CLEARED,
});

export const getRegistrationsHistoryReports = params => async (dispatch, getStore) => {
    dispatch(setPagination(PAGINATION_KEYS.registrationsHistory, { isFetching: true }));

    let currentData = getStore().reports.registrationsHistory.data;
    let newData = params.offset > 0 ? currentData : [];

    const { info, item } = await ReportsService.getRegistrationsHistoryReports(params);

    if (!info.success) {
        dispatch(setPagination(PAGINATION_KEYS.registrationsHistory, { isFetching: false }));
        return;
    }

    const { items: receivedData, summary = {} } = item;

    const hasMore = receivedData.length >= params.limit;
    newData = newData.concat(receivedData);

    dispatch(
        setRegistrationsHistoryReports({
            data: newData,
            summary,
            playerTable: params.playerTable,
        }),
    );

    dispatch(
        setPagination(PAGINATION_KEYS.registrationsHistory, {
            hasMore,
            page: params.offset,
            size: params.limit,
            isFetching: false,
        }),
    );

    return item;
};

export const setRegistrationsHistoryReports = payload => ({
    type: REGISTRATIONS_HISTORY_REPORTS_CHANGED,
    payload,
});

export const clearRegistrationsHistoryReports = () => ({
    type: REGISTRATIONS_HISTORY_REPORTS_CLEARED,
});

export const getSportPerformanceReport = params => async dispatch => {
    dispatch(clearSportPerformanceData());
    dispatch(setSportsPerformanceDataLoading(true));

    const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.sportsPerformance);

    const { info, item } = await ReportsService.getSportPerformanceReport(params, cancelToken);

    if (!info.success) {
        dispatch(setSportsPerformanceDataLoading(false));
        return;
    }

    dispatch(setSportsPerformanceData(item));
};

export const setSportsPerformanceData = payload => ({
    type: SPORT_PERFORMANCE_DATA_CHANGED,
    payload,
});

export const setSportsPerformanceDataLoading = payload => ({
    type: SPORT_PERFORMANCE_LOADING_CHANGED,
    payload,
});

export const clearSportPerformanceData = () => ({
    type: SPORT_PERFORMANCE_DATA_CLEARED,
});

export const getMoneyTransaction = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentMoneyTransactions = store.reports.moneyTransactions.reports;

    dispatch(setMoneyTransactions(params.offset > 0 ? currentMoneyTransactions : []));

    dispatch(
        setPagination(PAGINATION_KEYS.moneyTransactions, {
            isFetching: true,
        }),
    );

    const { info, items } = await ReportsService.getMoneyTransaction(params);

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.moneyTransactions, {
                isFetching: false,
            }),
        );
        return;
    }

    let newMoneyTransactions = [];

    if (params.offset > 0) {
        newMoneyTransactions = currentMoneyTransactions.concat(items);
    } else {
        newMoneyTransactions = items;
    }
    const hasMore = items.length >= params.limit;

    dispatch(setMoneyTransactions(newMoneyTransactions));

    dispatch(
        setPagination(PAGINATION_KEYS.moneyTransactions, {
            page: params.offset,
            size: params.limit,
            hasMore,
            isFetching: false,
        }),
    );

    return newMoneyTransactions;
};

export const setMoneyTransactions = payload => ({
    type: MONEY_TRANSACTIONS_DATA_CHANGED,
    payload,
});

export const getDetails = params => async dispatch => {
    dispatch(setMoneyTransactionsDetails({ [params.operationId]: { isFetching: true } }));

    const { info, item } = await ReportsService.getDetails(params);

    if (!info.success) return;

    dispatch(setMoneyTransactionsDetails({ [params.operationId]: { ...item, isFetching: false } }));
};

export const setMoneyTransactionsDetails = payload => ({
    type: MONEY_TRANSACTIONS_DETAILS_CHANGED,
    payload,
});

export const clearMoneyTransactionsAllData = () => ({
    type: MONEY_TRANSACTIONS_ALL_DATA_CLEARED,
});

export const getInactiveReports = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentInactiveReports = store.reports.inactivePlayersReport;

    dispatch(setInactivePlayersReport(params.offset > 0 ? currentInactiveReports : []));

    dispatch(
        setPagination(PAGINATION_KEYS.inactivePlayersReport, {
            isFetching: true,
        }),
    );

    const { info, items } = await ReportsService.getInactivePlayers(params);

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.inactivePlayersReport, {
                isFetching: false,
            }),
        );
        return;
    }

    let newInactivePlayersReport = [];

    if (params.offset > 0) {
        newInactivePlayersReport = currentInactiveReports.concat(items);
    } else {
        newInactivePlayersReport = items;
    }
    const hasMore = items.length >= params.limit;

    dispatch(setInactivePlayersReport(newInactivePlayersReport));

    dispatch(
        setPagination(PAGINATION_KEYS.inactivePlayersReport, {
            page: params.offset,
            size: params.limit,
            hasMore,
            isFetching: false,
        }),
    );

    return newInactivePlayersReport;
};

export const setInactivePlayersReport = payload => ({
    type: INACTIVE_PLAYERS_REPORT_DATA_CHANGED,
    payload: payload,
});

export const clearInactivePlayersReport = () => ({
    type: INACTIVE_PLAYERS_REPORT_DATA_CLEARED,
});

export const getAuditTrailReport = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentAuditReport = store.reports.auditTrailReport;

    dispatch(setAuditTrailReport(params.offset > 0 ? currentAuditReport : []));

    dispatch(
        setPagination(PAGINATION_KEYS.auditTrailReport, {
            isFetching: true,
        }),
    );

    const { info, items } = await ReportsService.getAuditTrailReport(params);

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.auditTrailReport, {
                isFetching: false,
            }),
        );
        return;
    }

    let newAuditTrailReport = [];

    if (params.offset > 0) {
        newAuditTrailReport = currentAuditReport.concat(items);
    } else {
        newAuditTrailReport = items;
    }
    const hasMore = items.length >= params.limit;

    dispatch(setAuditTrailReport(newAuditTrailReport));

    dispatch(
        setPagination(PAGINATION_KEYS.auditTrailReport, {
            page: params.offset,
            size: params.limit,
            hasMore,
            isFetching: false,
        }),
    );

    return newAuditTrailReport;
};

const setAuditTrailReport = payload => ({
    type: AUDIT_TRAIL_REPORT_DATA_CHANGED,
    payload,
});

export const clearAuditTrailReport = () => ({
    type: AUDIT_TRAIL_REPORT_DATA_CLEARED,
});

export const getTicketOperationsHistory = params => async (dispatch, getStore) => {
    const store = getStore();
    const currentData = store.reports.ticketOperationsHistory.data || [];

    dispatch(
        setPagination(PAGINATION_KEYS.ticketOperationsHistory, {
            isFetching: true,
        }),
    );

    const cancelToken = getNewCancelToken(CANCEL_TOKEN_KEYS.ticketOperationsHistory);

    const { info, items: data } = await ReportsService.getTicketOperationsHistory({
        params,
        cancelToken,
    });

    if (!info.success) {
        dispatch(
            setPagination(PAGINATION_KEYS.ticketOperationsHistory, {
                isFetching: false,
            }),
        );
        return;
    }

    let newData = [];

    if (params.pageIndex > 0) {
        newData = currentData.concat(data);
    } else {
        newData = data;
    }

    const hasMore = data.length >= params.pageSize;

    dispatch(setTicketOperationsHistory(newData));

    dispatch(
        setPagination(PAGINATION_KEYS.ticketOperationsHistory, {
            page: params.pageIndex,
            hasMore,
            isFetching: false,
        }),
    );
};

export const setTicketOperationsHistory = payload => ({
    type: TICKET_OPERATIONS_HISTORY_REPORTS_CHANGED,
    payload,
});

export const clearTicketOperationsHistory = () => ({
    type: TICKET_OPERATIONS_HISTORY_REPORTS_CLEARED,
});
